module.exports = {"appTitle":"Diversity on Screen","appTagline":"Now you'll know just what you're watching."}


//////////////////
// WEBPACK FOOTER
// ./src/assets/text.json
// module id = 33
// module chunks = 0